import { Terminator, UUID } from "@opendaw/lib-std";
import { Propagation } from "@opendaw/lib-box";
import { TimelineBoxAdapter } from "./TimelineBoxAdapter";
export class MarkerBoxAdapter {
    static Comparator = (a, b) => a.position - b.position;
    type = "marker-event";
    #terminator = new Terminator();
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#terminator.own(this.#box.subscribe(Propagation.Children, (update) => {
            if (this.trackAdapter.isEmpty()) {
                return;
            }
            if (update.type === "primitive" || update.type === "pointer") {
                const track = this.trackAdapter.unwrap();
                if (this.#box.position.address.equals(update.address)) {
                    track.onSortingChanged();
                }
                else {
                    track.dispatchChange();
                }
            }
        }));
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get position() { return this.#box.position.getValue(); }
    get plays() { return this.#box.plays.getValue(); }
    get hue() { return this.#box.hue.getValue(); }
    get label() { return this.#box.label.getValue(); }
    get trackAdapter() {
        return this.#box.track.targetVertex
            .map(vertex => this.#context.boxAdapters.adapterFor(vertex.box, TimelineBoxAdapter).markerTrack);
    }
    terminate() { this.#terminator.terminate(); }
    toString() { return `{MarkerBoxAdapter ${UUID.toString(this.#box.address.uuid).substring(0, 4)}, plays: ${this.plays}`; }
}
